var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDatePickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999969 6.00028C0.999512 5.76662 1.08089 5.54019 1.22997 5.36028L5.22997 0.360276C5.39971 0.156059 5.64362 0.0276347 5.90804 0.00325494C6.17247 -0.0211248 6.43575 0.0605371 6.63997 0.230276C6.84419 0.400014 6.97261 0.643926 6.99699 0.908352C7.02137 1.17278 6.93971 1.43606 6.76997 1.64028L3.28997 6.00028L6.60997 10.3603C6.69303 10.4626 6.75507 10.5803 6.7925 10.7066C6.82993 10.8329 6.84202 10.9654 6.82808 11.0965C6.81414 11.2275 6.77445 11.3545 6.71127 11.4701C6.6481 11.5857 6.5627 11.6878 6.45997 11.7703C6.35715 11.8619 6.23652 11.9312 6.10565 11.974C5.97477 12.0168 5.83647 12.0321 5.69941 12.019C5.56235 12.0058 5.42947 11.9645 5.30912 11.8976C5.18876 11.8307 5.08351 11.7397 4.99997 11.6303L1.16997 6.63028C1.04445 6.44519 0.984598 6.22338 0.999969 6.00028Z",
    fill: "#0E103B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDatePickerIcon);
export default __webpack_public_path__ + "static/media/arrow-date-picker-icon.4f45bafe06264c1a77e67ffe1d2ff6ee.svg";
export { ForwardRef as ReactComponent };